import { render, staticRenderFns } from "./DreamITS.vue?vue&type=template&id=57229d5e&scoped=true&"
import script from "./DreamITS.vue?vue&type=script&lang=js&"
export * from "./DreamITS.vue?vue&type=script&lang=js&"
import style0 from "./DreamITS.vue?vue&type=style&index=0&id=57229d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57229d5e",
  null
  
)

export default component.exports